(function () {
  if (window.__FITMENT_AUTOCOMPLETE_READY__) return;
  window.__FITMENT_AUTOCOMPLETE_READY__ = true;

  const APP_ID = String(window.__FITMENT_ALGOLIA_APP_ID || "").trim();
  const SEARCH_KEY = String(window.__FITMENT_ALGOLIA_SEARCH_KEY || "").trim();
  const INDEX_NAME = String(window.__FITMENT_ALGOLIA_INDEX || "dt_fitment").trim();

  if (!APP_ID || !SEARCH_KEY || !INDEX_NAME) {
    console.warn("[fitment] Missing Algolia config");
    return;
  }

  const ALGOLIA_URL = `https://${APP_ID}-dsn.algolia.net/1/indexes/${encodeURIComponent(
    INDEX_NAME
  )}/query`;

  const qs = (s, r = document) => { try { return r.querySelector(s); } catch { return null; } };
  const qsa = (s, r = document) => { try { return Array.from(r.querySelectorAll(s)); } catch { return []; } };

  const debounce = (fn, wait = 220) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const normalize = (v) => (v || "").toString().trim();

  const escapeHtml = (s) =>
    (s || "").toString()
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  /* ──────────────────────────────────────────────
    Tire helpers (full + prefix)
  ────────────────────────────────────────────── */
  function normalizeTireSize(value) {
    return (value || "")
      .toString()
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "")
      .replace(/^P/, "");
  }

  // Devuelve { width, aspect, rim?, normalizedFull?, normalizedPrefix? }
  function parseTireQuery(input) {
    const raw = normalize(input).toLowerCase();
    if (!raw) return null;

    // dejamos solo números y 'r'
    const cleaned = raw.replace(/[^0-9r]/g, "");

    // 1) Full: 22545r17 / 2254517 / 225/45R17
    let m = cleaned.match(/^(\d{3})(\d{2})r?(\d{2})$/);
    if (m) {
      const width = m[1], aspect = m[2], rim = m[3];
      return {
        kind: "full",
        width, aspect, rim,
        normalizedFull: `${width}/${aspect}R${rim}`,
        prefix: `${width}/${aspect}R` // útil para buscar variantes
      };
    }

    // 2) Prefix: 22545 (solo ancho+perfil)
    // También soporta "225/45" o "225-45" porque arriba ya lo limpiamos a 22545
    m = cleaned.match(/^(\d{3})(\d{2})$/);
    if (m) {
      const width = m[1], aspect = m[2];
      return {
        kind: "prefix",
        width, aspect,
        // buscamos prefijo 225/45R para que aparezcan R17, R18...
        normalizedPrefix: `${width}/${aspect}R`,
      };
    }

    return null;
  }

  function getIntent(query) {
    const q = normalize(query);
    if (!q) return "empty";

    const tq = parseTireQuery(q);
    if (tq) return "tire_size";

    if (/^\d{4}$/.test(q)) return "year";
    if (/^[a-z]/i.test(q)) return "text";
    return "mixed";
  }

  function getTireFromHit(hit) {
    return (
      normalizeTireSize(hit.pmetric) ||
      normalizeTireSize(hit.tire_size_front) ||
      normalizeTireSize(hit.tire_size_rear) ||
      ""
    );
  }

  // Extrae un "sizeKey" tipo 225/45R17 desde hit (si se puede)
  function extractSizeKey(hit) {
    const s = getTireFromHit(hit);
    // Acepta 225/45R17 o 225/45ZR17 (si llegara)
    const m = s.match(/^(\d{3})\/(\d{2})R?Z?(\d{2})$/i);
    if (!m) return s || "";
    return `${m[1]}/${m[2]}R${m[3]}`.toUpperCase();
  }

  function rimFromSizeKey(sizeKey) {
    const m = (sizeKey || "").match(/R(\d{2})$/i);
    return m ? Number(m[1]) : 999;
  }

  /* ──────────────────────────────────────────────
    Algolia Search
  ────────────────────────────────────────────── */
  async function algoliaSearch(query, hitsPerPage = 50) {
    const payload = {
      query,
      hitsPerPage,
      attributesToRetrieve: [
        "objectID",
        "label",
        "year",
        "make",
        "model",
        "submodel",
        "pmetric",
        "tire_size_front",
        "tire_size_rear",
      ],
      typoTolerance: true,
      removeWordsIfNoResults: "lastWords",
    };

    const res = await fetch(ALGOLIA_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Algolia-API-Key": SEARCH_KEY,
        "X-Algolia-Application-Id": APP_ID,
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const t = await res.text().catch(() => "");
      throw new Error(`[fitment] Algolia ${res.status}: ${t}`);
    }

    return res.json();
  }

  /* ──────────────────────────────────────────────
    UI
  ────────────────────────────────────────────── */
  function ensureUI() {
    return {
      box: qs("[data-fitment-suggestions]"),
      items: qs("[data-fitment-items]"),
      title: qs("[data-fitment-suggestions] .fitment-title"),
    };
  }

  function hideUI() {
    const { box, items } = ensureUI();
    if (box) box.classList.add("hidden");
    if (items) items.innerHTML = "";
  }

  function showUI() {
    const { box } = ensureUI();
    if (box) box.classList.remove("hidden");
  }

  function setTitle(text) {
    const { title } = ensureUI();
    if (title) title.textContent = text || "Vehicle / Fitment";
  }

  function renderHits(hits, intent, onPick) {
    const { items } = ensureUI();
    if (!items) return;

    if (!hits.length) {
      items.innerHTML = `
        <div class="fitment-item" style="opacity:.6">
          <div>
            <div class="fitment-label">No results</div>
            <div class="fitment-meta">Try “Toyota Corolla 2020”, “235/70R20” or “22545”</div>
          </div>
        </div>`;
      return;
    }

    items.innerHTML = hits.map((hit) => {
      const sizeKey = extractSizeKey(hit);
      const label =
        intent === "tire_size"
          ? sizeKey
          : `${hit.year || ""} ${hit.make || ""} ${hit.model || ""} ${hit.submodel || ""}`
              .replace(/\s+/g, " ")
              .trim();

      const meta =
        intent === "tire_size"
          ? "Tire size"
          : (sizeKey ? `Tire: ${sizeKey}` : "");

      return `
        <div class="fitment-item" data-id="${escapeHtml(hit.objectID)}" data-size="${escapeHtml(sizeKey)}">
          <div>
            <div class="fitment-label">${escapeHtml(label)}</div>
            ${meta ? `<div class="fitment-meta">${escapeHtml(meta)}</div>` : ""}
          </div>
          <div class="fitment-size">${escapeHtml(sizeKey)}</div>
        </div>`;
    }).join("");

    qsa(".fitment-item[data-id]", items).forEach(el => {
      el.addEventListener("click", () => {
        const hit = hits.find(h => String(h.objectID) === el.dataset.id);
        if (hit) onPick(hit);
      });
    });
  }

  /* ──────────────────────────────────────────────
    INPUT + STATE
  ────────────────────────────────────────────── */
  function getInput() {
    return qs(".ais-SearchBox-input") || qs(".ais-search-box input");
  }

  let suppressUntil = 0;
  let lastAppliedValue = "";

  function applyPickToInput(hit) {
    const input = getInput();
    if (!input) return;

    const q = extractSizeKey(hit) || getTireFromHit(hit);
    if (!q) {
      hideUI();
      return;
    }

    suppressUntil = Date.now() + 900;
    lastAppliedValue = q;

    hideUI();

    input.value = q;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    input.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true, key: "Enter" }));

    input.focus();
    if (input.setSelectionRange) {
      input.setSelectionRange(q.length, q.length);
    }

    setTimeout(hideUI, 120);
    setTimeout(hideUI, 450);
  }

  function dedupeAndSortTireHits(hits, prefixInfo) {
    // Solo tamaños, dedupe por sizeKey
    const map = new Map();

    for (const h of hits) {
      const sizeKey = extractSizeKey(h);
      if (!sizeKey) continue;

      // Si estamos en "prefix", filtrar por el prefijo exacto 225/45R
      if (prefixInfo?.kind === "prefix") {
        const expectedPrefix = `${prefixInfo.width}/${prefixInfo.aspect}R`.toUpperCase();
        if (!sizeKey.startsWith(expectedPrefix)) continue;
      }

      // dedupe: el primero que llegue gana (o puedes elegir el más completo)
      if (!map.has(sizeKey)) map.set(sizeKey, h);
    }

    const unique = Array.from(map.values());

    unique.sort((a, b) => {
      const ra = rimFromSizeKey(extractSizeKey(a));
      const rb = rimFromSizeKey(extractSizeKey(b));
      if (ra !== rb) return ra - rb;
      return extractSizeKey(a).localeCompare(extractSizeKey(b));
    });

    return unique;
  }

  const handleInput = debounce(async () => {
    const input = getInput();
    if (!input) return;

    if (Date.now() < suppressUntil) {
      hideUI();
      return;
    }

    const q = normalize(input.value);
    if (q.length < 2 || q === lastAppliedValue) {
      hideUI();
      return;
    }

    const intent = getIntent(q);

    try {
      showUI();

      // ── Tire intent: soporta full + prefix ──
      if (intent === "tire_size") {
        const tq = parseTireQuery(q);

        // Si por alguna razón falló, caemos al query normal
        const searchQuery =
          tq?.kind === "full"
            ? tq.normalizedFull
            : (tq?.normalizedPrefix || q);

        // Para prefijo necesitamos más hits para capturar varios rines
        const data = await algoliaSearch(searchQuery, tq?.kind === "prefix" ? 200 : 80);
        const hits = dedupeAndSortTireHits(data.hits || [], tq);

        setTitle("Tire sizes");
        renderHits(hits, "tire_size", applyPickToInput);

        return;
      }

      // ── Otros intents: vehículos ──
      const data = await algoliaSearch(q, 50);
      setTitle("Vehicle / Fitment");
      renderHits(data.hits || [], intent, applyPickToInput);
    } catch (e) {
      console.error(e);
      hideUI();
    }
  }, 220);

  function bind() {
    const input = getInput();
    if (!input) return;

    // Si el DOM se re-renderiza, puede venir un input nuevo
    // En ese caso, el dataset no existe y se vuelve a bindear
    if (input.dataset.fitmentBound === "1") return;

    input.dataset.fitmentBound = "1";
    input.addEventListener("input", handleInput);
    input.addEventListener("focus", handleInput);
    input.addEventListener("blur", () => setTimeout(hideUI, 200));
  }

  window.addEventListener("ais-rendered", () => setTimeout(bind, 0));
  window.addEventListener("improved-search:ready", () => setTimeout(bind, 0));
  window.addEventListener("ais-filter-applied", () => setTimeout(bind, 0));
  window.addEventListener("load", () => setTimeout(bind, 0));
  
})();

